module.exports = __webpack_public_path__ + "assets/images/a92397a12b9faaf03b391dc666987c6c.png";